<template>
    <v-container pt-2>
        <v-layout column>
            <a-date-field clearable label="Aniversariantes entre"
                          readonly v-model="filterData.dateRange[0]" xs12></a-date-field>
            <a-date-field clearable label="e" readonly v-model="filterData.dateRange[1]" xs12></a-date-field>

            <a-select-field obj="exchangeStatus" multiple label="Clientes com cheque" clearable
                            v-model="filterData.exchangeStatusId"></a-select-field>

            <v-switch label="Com Débitos" color="warning" hide-details v-model="filterData.hasDebit"></v-switch>

        </v-layout>
    </v-container>
</template>

<script>
   export default {

      props: {
         reloadKey: {
            type: Number,
            required: false
         },
         execute: {
            type: Boolean,
            required: false,
            default: false
         }
      },

      data() {
         return {
            processing: false,
            filterData: {
               dateRange: [null, null],
               exchangeStatusId: null,
               hasDebit: false
            }
         }
      },

      watch: {
         reloadKey: {
            immediate: true,
            handler: function () {
               this.reloadFilters();
            }
         },
         execute(val) {
            val && this.applyFilter();
         }
      },

      methods: {
         applyFilter() {
            let filters = [];

            let rangeLabel = '';
            if (this.filterData.dateRange) {
               rangeLabel = 'Aniversariantes';
               let dateRange = this.filterData.dateRange.filter(d => d !== null);
               dateRange.forEach((v, i) => dateRange[i] = this.$moment(v).format('MMM/D'));

               if (dateRange.length === 2) {
                  rangeLabel += (dateRange[0] === dateRange[1]) ? ': ' + dateRange[0] : ' entre ' + dateRange.join(' e ');
               } else if (dateRange.length) {
                  rangeLabel += ': ' + dateRange[0];
               } else {
                  rangeLabel = '';
               }

               if (!rangeLabel) {
                  this.filterData.dateRange = [null, null];
               }
            }

            filters.push({
               field: 'dateRange',
               value: this.filterData.dateRange,
               label: rangeLabel
            });

            filters.push({
               field: 'hasDebit',
               value: this.filterData.hasDebit,
               label: this.filterData.hasDebit ? 'Clientes com débitos' : ''
            });

            let statusLabels = [];
            let statusKeys = [];
            if (this.filterData.exchangeStatusId) {
               this.filterData.exchangeStatusId.forEach(s => {
                  statusKeys.push(s.id);
                  statusLabels.push(s.name);
               });
            }
            filters.push({
               field: 'exchangeStatusId',
               value: statusKeys.join(),
               label: 'Cheque(s): ' + statusLabels.join(', ')
            });

            this.$store.dispatch('updateAllPageFilters', filters);

            setTimeout(() => this.$emit('close'), 150);
         },

         reloadFilters() {
            this.$util.updateObj(this.filterData, this.$store.getters.activePageFilters);

         }
      }

   }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/ClientFilter.vue